import { defineStore } from 'pinia'
import { ref, type Ref } from 'vue'

import { isAuthenticated } from '@/libs/auth'
import type { UserData } from '@/types/User'

export const useAppStore = defineStore('app', () => {
    const windowWidth: Ref<number> = ref(0)
    const loaderActive: Ref<number> = ref(0)
    const mobileMenuOpen: Ref<boolean> = ref(false)
    const userData: Ref<UserData> = ref({
        id: '',
        firstname: '',
        lastname: '',
        email: '',
        selected_manager: '',
        token: ''
    })

    const resizeHandler = (): void => {
        windowWidth.value = window.innerWidth
    }

    const isMobile = (): boolean => {
        return windowWidth.value < 1024
    }

    const isMediumScreen = (): boolean => {
        return windowWidth.value < 768
    }

    const startLoading = () => {
        loaderActive.value++
    }
    const stopLoading = () => {
        if (loaderActive.value > 0) loaderActive.value--
    }

    const setLogin = (data: UserData, jwt: string) => {
        localStorage.setItem('userData', JSON.stringify(data))
        localStorage.setItem('JWT', jwt)
        userData.value = data
    }

    const setLogout = () => {
        localStorage.removeItem('JWT')
        localStorage.removeItem('userData')
        userData.value = {
            id: '',
            firstname: '',
            lastname: '',
            email: '',
            selected_manager: '',
            token: ''
        }
    }

    const setUserData = (data: UserData) => {
        userData.value = data
    }

    // getters
    const isLoaderActive = () => {
        return !!loaderActive.value
    }

    const getUserData = () => {
        return userData.value
    }

    const getUserLoggedIn = () => {
        return isAuthenticated()
    }

    return {
        windowWidth,
        mobileMenuOpen,
        isMobile,
        isMediumScreen,
        resizeHandler,
        setLogin,
        setLogout,
        isLoaderActive,
        startLoading,
        stopLoading,
        setUserData,
        getUserData,
        getUserLoggedIn
    }
})
